<template>
	<v-container class="fill-height height-minus-navbar align-start">
		<v-row>
			<v-col cols="12">
				<Table :data="data" v-if="data" v-show="data" :dummyData="dummyData" />
			</v-col>
		</v-row>
		<v-snackbar v-model="snackbar.isOpen" :color="snackbar.color" left>
      		{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snackbar.isOpen=false">Ок</v-btn>
			</template>
		</v-snackbar>
		<v-dialog v-model="formDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<template v-slot:activator="{ on, attrs }">
				<v-btn  fixed bottom right fab icon elevation="2" class="red white--text" v-bind="attrs" v-on="on">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
			</template>
			<v-card>
				<v-toolbar dark color="primary">
					<v-toolbar-title>Settings</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon dark @click="formDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-col cols="12">
					<v-col cols="12">
						<v-row v-cloak @drop.prevent="addFile" @dragover.prevent @dragover="dragging=true" @drop="dragging=false" @dragleave="dragging=false">
							<v-col cols="6">
								<header class="title mb-6">Загрузить данные</header>
								<v-file-input
									v-model="files"
									counter
									label="Загрузка"
									multiple
									placeholder="Выберите файлы"
									prepend-icon="mdi-paperclip"
									outlined
									:show-size="1000"
								>
									<template v-slot:selection="{ index, text }">
										<v-chip dark label small>
											{{ text }}
										</v-chip>
									</template>
								</v-file-input>
								<p align="center">или</p>
								<v-alert class="body-2 dropzone" align="center" :class="{'grey lighten-3':!dragging, dragover:dragging}">
									<v-icon>mdi-upload</v-icon> Перетащите файлы в эту область
								</v-alert>
								<v-col cols="12" align="right" class="px-0">
									<v-btn color="blue lighten-1" class="mt-3" :class="{ 'theme--dark':files.length }" :disabled="!files.length">Загрузить</v-btn>
								</v-col>
							</v-col>
							<v-col cols="6">
								<header class="title mb-6">Ввести вручную</header>
								<v-textarea outlined color="blue lighten-1" label="Текст" v-model="inputText"></v-textarea>
								<v-col cols="12" align="right" class="px-0">
									<v-btn color="blue lighten-1" :class="{ 'theme--dark':inputText.length }" :disabled="!inputText.length || pending" :loading="pending" @click="sendText">Отправить</v-btn>
								</v-col>
							</v-col>
						</v-row>
					</v-col>
				</v-col>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import Table from './Table'

export default {
	name:"TextManagement",
	props: { data:{ default:null }, projectId:{ required:true }, dummyData:{ default:false } },
	components: { Table },
	data: () => ({
		files:[], inputText:'', dragging:false, snackbar:{ text:'', color:'success', isOpen:false }, pending:false, formDialog:false
	}),
	created(){
		this.$eventBus.$on('text_added', status => this.textAdded(status))
		this.$eventBus.$on('text_removed', status => this.textRemoved(status))
	},
	beforeDestroy(){
		this.$eventBus.$off('text_added')
		this.$eventBus.$off('text_removed')
	},
	methods: {
		addFile(e) {
			let droppedFiles = e.dataTransfer.files
			if(!droppedFiles) return
			([...droppedFiles]).forEach(f =>  this.files.push(f));
		},
		sendText(){
			this.$eventBus.$emit('add_text', this.inputText)
			this.pending = true
		},
		textAdded(status){
			if(status) this.inputText = ''
			this.snackbar.text = status ? 'Текст добавлен' : 'Ошибка добавления текста'
			this.snackbar.color = status ? 'success' : 'error'
			this.snackbar.isOpen = true
			this.pending = false
		},
		textRemoved(status){
			if(status) this.inputText = ''
			this.snackbar.text = status ? 'Текст удалён' : 'Ошибка удаления текста'
			this.snackbar.color = status ? 'success' : 'error'
			this.snackbar.isOpen = true
			this.pending = false
		}
	}
}
</script>

<style lang="scss">
	.dropzone.dragover { border-color:#888!important; border-style:dashed!important; }
</style>